import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useNavBarPath = () => {
  const { pathname } = useLocation();

  const [isExpanded, updateIsExpanded] = useState(true);
  const [isProject, updateIsProject] = useState(false);
  const [isAdmin, updateIsAdmin] = useState(false);

  useEffect(() => {
    updateIsProject(
      pathname.includes('projects') &&
        new RegExp(/projects\/((?!(?=new)).*)/g).test(pathname),
    );
    updateIsAdmin(
      pathname.includes('settings') &&
        new RegExp(
          /settings\/((?!(?=plugs || ?=test_lab || ?=bug_report || ?=collaboration || ?=product_management || ?=ci_cd)).*)/g,
        ).test(pathname),
    );
    updateIsExpanded(
      !(
        (pathname.includes('td') ||
          pathname.includes('settings') ||
          pathname.includes('agents') ||
          pathname.includes('agents/new') ||
          pathname.includes('projects') ||
          pathname.includes('salesforce') ||
          pathname.includes('ai-journey') ||
          pathname.includes('playground') ||
          pathname.includes('save_points')) &&
        (new RegExp(/td\/((?!(?=(\d+))).*)\/(\d+)/g).test(pathname) ||
          new RegExp(/td\/\d+\/plans\/\d+(?:\/|$)/g).test(pathname) ||
          new RegExp(/settings/g).test(pathname) ||
          new RegExp(/projects/g).test(pathname) ||
          new RegExp(/\/agents\/+/g).test(pathname) ||
          new RegExp(/\/salesforce\/+/g).test(pathname) ||
          new RegExp(/ai-journey/g).test(pathname) ||
          new RegExp(/playground/g).test(pathname) ||
          new RegExp(/\/save_points+/g).test(pathname))
      ) &&
        !new RegExp(/td\/(\d+)\/(cases|elements)\/filters\/?(\d*)/g).test(
          pathname,
        ),
    );
  }, [pathname]);
  return {
    isExpanded,
    isProject,
    isAdmin,
  };
};
